import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

interface ErrorState {
  message: string | null;
  isError: boolean;
}

const initialState: ErrorState = {
  message: null,
  isError: false,
};

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
      state.isError = true;
    },
    clearError: (state) => {
      state.message = null;
      state.isError = false;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;

export const selectError = (state: RootState) => state.error;

export default errorSlice.reducer;